module.exports = __webpack_public_path__ + "static/media/signal-1.f250fea0.svg";